const objStyles = {
    position: 'fixed',
    pointerEvents: 'none',
    zIndex: 1000,
    width: '0px',
    height: '0px',
};
const minSize = 18;
export default class TourSpotlight {
    updateInterval: number = 0;
    crateSpotlight(spotlightId: string): HTMLElement {
        let spotlight = document.getElementById(spotlightId);
        if (spotlight) {
            return spotlight;
        }
        spotlight = document.createElement('div');
        Object.assign(spotlight.style, objStyles);
        document.body.append(spotlight);
        return spotlight;
    }
    createInterval(bind: Array<{ spotlightId: string; iconSelector: string }>): void {
        if (this.updateInterval) {
            clearInterval(this.updateInterval);
        }
        this.updateInterval = window.setInterval(() => {
            bind.forEach(({ spotlightId, iconSelector }) => {
                const targetElement = document.querySelector<HTMLElement>(iconSelector);
                if (!targetElement) {
                    return;
                }
                const spotlight = this.crateSpotlight(spotlightId);
                const rect = targetElement.getBoundingClientRect();

                let shrink = rect.width - minSize;
                const Kw = shrink > 0 ? Math.ceil(shrink / 2) : 0;
                shrink = rect.height - minSize;
                const Kh = shrink > 0 ? Math.ceil(shrink / 2) : 0;

                spotlight.style.position = 'fixed';
                spotlight.style.top = `${rect.top + Kh}px`;
                spotlight.style.left = `${rect.left + Kw}px`;
                spotlight.style.width = `${minSize}px`;
                spotlight.style.height = `${minSize}px`;
                spotlight.id = spotlightId;
            });
        }, 1000);
    }
    removeSpotLight(spotlightId: string): void {
        const spotlight = document.getElementById(spotlightId);
        if (spotlight) {
            spotlight.remove();
        }
        if (this.updateInterval) {
            clearInterval(this.updateInterval);
            this.updateInterval = 0;
        }
    }
}
